import React from "react";
import { Routes, Route } from "react-router-dom";
import { PATH } from "@configs";
import { AuthenticationPage } from "@pages/authorization/Authentication";
import { CallBackPage } from "@pages/authorization/Callback";
import { TokenExchangePage } from "@pages/authorization/TokenExchange";
import { CallBackPage as UnlinkCallBackPage } from "@pages/unlink/CallbackPage";
import { MappingSuccessPage } from "@pages/notify/MappingSuccessPage";
import { MappingFailPage } from "@pages/notify/MappingFailPage";
import { MappingIsNotAvailablePage } from "@pages/notify/MappingIsNotAvailablePage";
import { AlreadyMappingPage } from "@pages/notify/AleadyMappingPage";
import { UIdIsNotAvailablePage } from "@pages/notify/UIdIsNotAvailablePage";
import { NoConsentPage } from "@pages/notify/NoConsentPage";
import { UnLinkSuccessPage } from "@pages/notify/UnLinkSuccessPage";
import { UnLinkFailPage } from "@pages/notify/UnLinkFailPage";
import { GrabMappingPage } from "@pages/grab/GrabMappingPage";

export const MainRoute: React.FC = () => {
  return (
    <Routes>
      <Route path={PATH.AUTHORIZE}>
        <Route index element={<AuthenticationPage />} />
        <Route path={PATH.AUTHORIZE_CALLBACK} element={<CallBackPage />} />
        <Route
          path={PATH.AUTHORIZE_TOKEN_EXCHANGE}
          element={<TokenExchangePage />}
        />
      </Route>

      <Route path={PATH.UNLINK}>
        <Route
          path={PATH.UNLINK_CALLBACK}
          element={<UnlinkCallBackPage />}></Route>
      </Route>

      <Route path={PATH.MAPPING_SUCCESS} element={<MappingSuccessPage />} />
      <Route path={PATH.MAPPING_FAIL} element={<MappingFailPage />} />
      <Route
        path={PATH.MAPPING_IS_NOT_AVAILABLE}
        element={<MappingIsNotAvailablePage />}
      />
      <Route
        path={PATH.MAPPING_ALREADY_MAPPING}
        element={<AlreadyMappingPage />}
      />
      <Route
        path={PATH.UID_IS_NOT_AVAILABLE}
        element={<UIdIsNotAvailablePage />}
      />
      <Route path={PATH.NO_CONSENT} element={<NoConsentPage />} />
      <Route path={PATH.UNLINK_SUCCESS} element={<UnLinkSuccessPage />} />
      <Route path={PATH.UNLINK_FAIL} element={<UnLinkFailPage />} />

      <Route path={PATH.GRAB}>
        <Route path={PATH.GRAB_MAPPING} element={<GrabMappingPage />} />
      </Route>
    </Routes>
  );
};
